export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20230318_0713_FC1_1198.0989d6a1.jpg";